import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Lightbulb, HeartHandshake, Puzzle, BookOpen, Flower2 } from 'lucide-react';
export function ClinicalApproachSection() {
  const principles = [{
    icon: Brain,
    title: 'Enfoque basado en evidencia',
    description: 'Técnicas respaldadas por la investigación científica, adaptadas a tu realidad.'
  }, {
    icon: HeartHandshake,
    title: 'Vínculo terapéutico',
    description: 'Construyo un espacio de confianza donde puedas expresarte sin miedo al juicio.'
  }, {
    icon: Puzzle,
    title: 'Visión integral',
    description: 'Exploro tu historia, contexto familiar y cultural para entender la raíz.'
  }, {
    icon: Lightbulb,
    title: 'Herramientas prácticas',
    description: 'Estrategias concretas para aplicar en tu día a día.'
  }, {
    icon: BookOpen,
    title: 'Psicoeducación',
    description: 'Te ayudo a entender qué pasa en tu mente y tu cuerpo.'
  }, {
    icon: Flower2,
    title: 'Crecimiento personal',
    description: 'Un camino de autoconocimiento y fortaleza interior.'
  }];
  return <section id="approach" className="py-24 bg-white" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-57">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-58">
            Mi enfoque clínico
          </h2>
          <p className="text-lg text-gray-600" data-id="element-59">
            Como psicóloga formada en Colombia, mi práctica se fundamenta en una
            comprensión profunda y humana.
          </p>
        </div>

        {/* Philosophy Card */}
        <div className="max-w-4xl mx-auto mb-16 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-60">
          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-61">
            <div className="w-12 h-12 bg-teal-700 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-62">
              <Brain className="w-6 h-6 text-white" data-id="element-63" />
            </div>
            <div data-id="element-64">
              <h3 className="font-serif text-xl font-bold text-gray-900 mb-3" data-id="element-65">
                ¿Por qué la psicología clínica?
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-66">
                La psicología clínica es mi vocación. Mi formación me permite
                evaluar, diagnosticar y tratar una amplia variedad de
                dificultades emocionales tanto en niños como en adultos. Creo
                profundamente en que cada persona tiene la capacidad de sanar y
                crecer.
              </p>
            </div>
          </div>
        </div>

        {/* Principles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-67">
          {principles.map((principle, index) => {
          const Icon = principle.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 border border-gray-200 hover:border-teal-200 transition-colors" data-id="element-68">
                <div className="w-10 h-10 bg-teal-50 rounded-lg flex items-center justify-center mb-4" data-id="element-69">
                  <Icon className="w-5 h-5 text-teal-700" data-id="element-70" />
                </div>
                <h3 className="font-serif text-lg font-bold text-gray-900 mb-2" data-id="element-71">
                  {principle.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-72">
                  {principle.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}